import { Box, styled } from '@material-ui/core';
import { Form } from 'formik';

export const Container = styled(Form)({
  width: '100%',
  height: '100%',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '0px 24px'
});

export const Content = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gridGap: theme.spacing(10),
  border: '1px solid #EEF0F2',
  borderRadius: 12,
  marginTop: 18
}));

export const InputContainer = styled(Box)({
  minWidth: 400,
  display: 'flex',
  flexDirection: 'column',
  gridGap: 12
});

export const Footer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 0px  '
});

export const GrayBox = styled(Box)({
  padding: 12,
  background: '#F0F0F4',
  borderRadius: 12
});
